import { Modal } from 'components';
import { config } from 'config/constants';
import { useNavigate } from 'react-router-dom';
import './UserImpersonationMovedNotice.scss';

/**
 * CB-40: el módulo legacy de User Impersonation (/sales) ya no es la
 * superficie autoritativa para agentes normales — solo is_tester sigue
 * usándolo (control/QA). Este componente reemplaza el contenido de esa
 * ruta cuando el agente no es tester, en vez de redirigirlo en silencio.
 */
export const UserImpersonationMovedNotice = () => {
  const navigate = useNavigate();
  const signInUrl = `${config.soda.sodaUrl ?? ''}/signin`;

  return (
    <Modal
      isOpen={true}
      onClose={() => navigate('/settings')}
      title="User Impersonation se movió"
      size="small"
    >
      <p className="user-impersonation-moved-notice__text">
        Las acciones de User Impersonation ahora se hacen en app.consoda.
        Ingresa con tu usuario en{' '}
        <a
          className="user-impersonation-moved-notice__link"
          href={signInUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {signInUrl}
        </a>
      </p>
    </Modal>
  );
};
